export default [
  {
    path: '/main/extract',
    meta: {
      tag: 'list_extract',
      name: 'Extratos',
      breadcrumb: 'Extratos'
    },
    component: () => import(/* webpackChunkName: "extract-list" */ '@/views/main/extract/Index.vue'),
    children: [
      {
        path: '',
        name: 'listextracts',
        meta: {
          tag: 'list_extract',
          name: 'Extratos',
          menu: 'extract',
        },
        component: () => import(/* webpackChunkName: "extract-list" */ '@/views/main/extract/List.vue')
      },
      {
        path: 'add',
        name: 'addextract',
        meta: {
          tag: 'add_extract',
          name: 'Adicionar | Extrato',
          breadcrumb: 'Adicionar Extrato',
          menu: 'extract'
        },
        component: () => import(/* webpackChunkName: "extract-add" */ '@/views/main/extract/Add.vue')
      }
    ]
  }
]
